import { EntityLinks } from '@griply/types';
import { getDirectGoalLifeAreaIds, resolveMovedGoalLinks } from '@griply/utils';
import { TreeItemMove } from 'shared/components/ui/virtualized-tree-list';
import { Goal, GoalLifeAreaLinkChange } from 'shared/types/goal';
import { ID } from 'shared/types/id';

export type GetLifeAreaLinkChangesOptions = {
  goalsMap: Record<ID, Goal>;
  // The life-area sections; Other, Completed and Archived are sections but no life area to link.
  lifeAreaIds: Set<ID>;
  links: EntityLinks;
};

// Only the link between the from/to sections moves; an inherited life area is no link of the goal's own.
export const getLifeAreaLinkChanges = (
  moves: TreeItemMove[],
  { goalsMap, lifeAreaIds, links }: GetLifeAreaLinkChangesOptions,
): GoalLifeAreaLinkChange[] =>
  moves.reduce<GoalLifeAreaLinkChange[]>(
    (acc, { itemId, fromParentId, toParentId }) => {
      const goal = goalsMap[itemId];
      if (!goal || toParentId === fromParentId) {
        return acc;
      }

      const moved = resolveMovedGoalLinks({
        currentParentIds: [],
        currentLifeAreaIds: getDirectGoalLifeAreaIds(goal, links),
        movedLifeAreaId: fromParentId,
        targetLifeAreaId: lifeAreaIds.has(toParentId) ? toParentId : undefined,
      });
      acc.push({ goalId: itemId, lifeAreaIds: moved.lifeAreaIds });
      return acc;
    },
    [],
  );
